import React from "react";
import { isAuthenticated } from "../../auth";

const Profile = () => {
  return (
    <div className="container mt-5">
      <h2 className="text-muted">Profile</h2>
      <div className="row">
        <div className="col-sm-3">
          <div className="card bg-info text-white border-0">
            <div className="card-body">
              <div className="d-flex ">
                <img
                  width="40"
                  height="40"
                  className="rounded-circle "
                  style={{ border: "1.2px solid #d9d9d9" }}
                  src={isAuthenticated().user.avatar}
                  alt="profile"
                />
                <p className="ml-2">
                  Hello, <br />
                  <span className="text-uppercase font-weight-bold">
                    {isAuthenticated().user.name}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
